<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <!-- Creator: CorelDRAW 2020 (64 Bit) -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="311px"
    height="450px"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 48.39 70.05"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
  >
    <g id="Layer_x0020_2">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <g id="_2264824185952">
        <path
          class="fil0"
          d="M37.32 24.75c1.07,-0.04 7.14,-0.12 7.76,0.05 0.12,0.63 0.04,29.24 0.04,30.77 -0.01,1.14 0.15,9.96 -0.11,10.21 -0.08,1.05 -1.35,0.92 -2.41,0.92l-37.47 0c-1.3,0 -1.59,-0.45 -1.59,-1.72l0 -47.64c0,-0.96 -0.23,-2.51 0.45,-2.98 0.57,-0.39 2.32,-0.24 3.13,-0.24l10.17 -0.02c0.17,-0.67 0.03,-2.51 0.07,-3.35 -2.23,-0.06 -4.56,-0.01 -6.8,0 -2.2,0 -4.56,-0.09 -6.73,0.03 -1.53,0.08 -2.86,1.41 -3.36,2.44 -0.68,1.41 -0.42,3.66 -0.43,5.42l0 35.33c0,3.91 -0.04,7.86 0,11.77 0.02,1.77 1.08,3.06 2.17,3.69 1.43,0.84 3.48,0.58 5.3,0.59 11.72,0.04 23.52,-0.06 35.24,0 0.92,0.01 1.87,0.07 2.7,-0.21 0.71,-0.23 1.47,-0.77 1.8,-1.18 1.3,-1.56 1.13,-2.36 1.13,-4.73l0 -38.22c0,-1.08 0.12,-1.75 -0.43,-2.52l-3.54 -3.81c-0.35,-0.3 -0.45,-0.39 -0.73,-0.71l-3.59 -3.76c-0.31,-0.29 -0.51,-0.46 -0.79,-0.74 -0.5,-0.5 -0.93,-0.96 -1.43,-1.47 -0.42,-0.43 -1,-1.14 -1.53,-1.46 -1.24,-0.75 -3.7,-0.52 -5.34,-0.48 -0.1,0.38 -0.08,2.91 -0.03,3.39l4.67 0c-0.05,2.04 -0.01,4.09 -0.01,6.13 0,1.52 -0.47,4.32 1.69,4.5z"
        />
        <path
          class="fil0"
          d="M14.35 17.16c-0.1,0.51 0.14,0.56 0.39,0.82 0.46,0.49 0.72,0.88 1.22,1.31l3.02 3.24c0.39,0.48 0.83,0.81 1.23,1.3l2.43 2.62c0.23,0.25 0.42,0.36 0.65,0.64 0.96,1.15 0.95,0.34 1.99,-0.61l7.84 -8.53c0.24,-0.26 0.43,-0.3 0.34,-0.8 -0.64,-0.21 -4.13,-0.05 -5.18,-0.08 0.11,-5.17 -0.04,-10.68 -0.01,-15.94 0.01,-1.2 -0.4,-1.12 -1.5,-1.13l-5.27 0c-1.14,-0.01 -1.46,0.01 -1.45,1.21 0.08,5.22 -0.04,10.6 0.01,15.85 -1.15,0.05 -5.02,-0.13 -5.71,0.1z"
        />
        <path
          class="fil0"
          d="M11.97 39.41c0.55,0.03 1.88,0.32 2.56,0.42l3.96 0.63 1.64 1.42c0.15,0.14 0.21,0.25 0.37,0.39l5.17 4.7c0.4,0.34 1.26,1.08 1.54,1.44l11.78 -0.02 -0.03 -9 -26.99 0.02z"
        />
        <path
          class="fil0"
          d="M9.41 39.43c-0.04,0.98 -0.09,8.56 0.05,8.98 2.81,0.21 5.63,0.52 8.44,0.64 3.01,0.14 6.12,-0.04 9.14,0.03 -0.29,-0.48 -0.61,-0.55 -0.93,-0.88 -0.36,-0.38 -0.5,-0.5 -0.86,-0.81l-1.76 -1.61c-0.37,-0.33 -0.3,-0.36 -0.91,-0.85 -0.32,-0.25 -0.55,-0.54 -0.87,-0.81 -0.69,-0.57 -3.27,-3.09 -3.6,-3.2 -0.51,-0.16 -4.86,-0.84 -5.8,-1.01 -0.92,-0.17 -1.96,-0.39 -2.9,-0.48z"
        />
        <path
          class="fil0"
          d="M29.38 58.46l0.04 -8.76c-0.57,-0.16 -4.35,-0.05 -5.25,-0.05 -1.71,-0.01 -3.52,0.06 -5.21,0l0 8.81 10.42 0z"
        />
        <path
          class="fil0"
          d="M19.06 38.75c2.18,0.08 8.04,0.05 10.23,-0.01l0.01 -7.74 -10.24 0.02 0 6.13 0 1.6z"
        />
        <path
          class="fil1"
          d="M45.01 65.78c0.26,-0.25 0.1,-9.07 0.11,-10.21 0,-1.53 0.08,-30.14 -0.04,-30.77 -0.62,-0.17 -6.69,-0.09 -7.76,-0.05 0.34,0.16 6.79,0.09 7.72,0.07 -0.05,10.25 0.04,20.5 0,30.75 -0.01,1.88 0.1,9.01 -0.03,10.21z"
        />
        <path
          class="fil1"
          d="M29.38 58.46l-10.42 0 0 -8.81c-0.11,0.22 -0.08,0.29 -0.08,0.57 -0.01,1.5 -0.08,7.89 0.06,8.29 0.49,0.08 4.39,0.02 5.23,0.02l4.98 0c0.3,-0.03 0.15,-0.03 0.23,-0.07z"
        />
        <path
          class="fil1"
          d="M17.29 14.1c0.21,-0.07 0.13,0.01 0.14,-0.73l-0.03 -2.64c-0.4,-0.15 -9.91,-0.05 -11.88,-0.06 -0.38,0 -1.37,-0.08 -1.69,0.11 2.17,-0.12 4.53,-0.03 6.73,-0.03 2.24,-0.01 4.57,-0.06 6.8,0 -0.04,0.84 0.1,2.68 -0.07,3.35z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
